import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormValidator } from '../../../helpers/form-validator';
import { Validator, Heading5, TitleIcon, Icon } from '../../widgets';
import { resetPassword } from '../../../actions/users';
import { setUserInfo, getUserInfo } from '../../../helpers/session';

const getRules = passwordDetail => {
    const isPasswordMatched = value => passwordDetail.password !== value;

    const rules = [{
        field: 'password',
        method: 'isEmpty',
        validWhen: false,
        message: 'Password is required.',
    },
    {
        field: 'confirmPassword',
        method: 'isEmpty',
        validWhen: false,
        message: 'Confirm password is required.',
    },
    {
        field: 'confirmPassword',
        method: isPasswordMatched,
        validWhen: false,
        message: "Confirm password doesn't match with password.",
    }]
    return rules;
}

const ResetPassword = props => {
    const { actions } = props;
    const [isSaving, setIsSaving] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const userInfo = getUserInfo();

    const [passwordDetail, setPasswordDetail] = useState({
        password: null,
        confirmPassword: null
    });

    const validator = new FormValidator(getRules(passwordDetail));
    const [validationInfo, setValidationInfo] = useState({ validation: validator.valid(), submitted: false });

    useEffect(() => {
        userInfo.showResetPassword && setOpenModal(userInfo.showResetPassword);
    }, [userInfo.showResetPassword])

    const handleChange = e => {
        const { name, value } = e.target;
        setPasswordDetail({ ...passwordDetail, [name]: value.length > 0 ? value : null });
    };

    const handleHide = () => {
        setUserInfo({ ...userInfo, showResetPassword: false });
        setOpenModal(false);
    }

    const handleSave = e => {
        e.preventDefault();
        const validation = validator.validate(passwordDetail);
        setValidationInfo({ validation, submitted: true });

        const params = { password: passwordDetail.password };

        if (validation.isValid) {
            const cb = (isSuccess) => {
                setIsSaving(false);
                if (isSuccess) handleHide();
            }

            actions.resetPassword(params, cb);
            setIsSaving(true);
        }
    };

    const Validation = validationInfo.submitted ? validator.validate(passwordDetail) : validationInfo.validation;

    return <Modal show={openModal} backdrop="static" size='md'>
        <Modal.Header style={{ color: '#064d9e' }}>
            <Modal.Title >
                <Heading5>
                    <TitleIcon className="fa fa-unlock-alt" />
                    Reset password
                </Heading5>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form autoComplete='off'>
                <Form.Group >
                    <Validator validation={Validation.password}>
                        <Form.Label>Password<Validator.Mand /></Form.Label>
                        <Form.Control
                            size='sm' type='password' placeholder='Password'
                            name='password' autoComplete="new-password"
                            value={passwordDetail.password || ""} onChange={handleChange}
                        />
                        <Validator.Text />
                    </Validator>
                </Form.Group>
                <Form.Group >
                    <Validator validation={Validation.confirmPassword}>
                        <Form.Label>Confirm Password<Validator.Mand /></Form.Label>
                        <Form.Control
                            size='sm' type='password' placeholder='Confirm Password'
                            name='confirmPassword' autoComplete="new-password"
                            value={passwordDetail.confirmPassword || ""} onChange={handleChange}
                        />
                        <Validator.Text />
                    </Validator>
                </Form.Group>
            </Form>
        </Modal.Body>
        <Modal.Footer style={{ display: "unset" }}>
            <Button variant='btn btn-outline-default btn-sm' onClick={handleHide} >Skip</Button>
            <Button variant='btn btn-primary btn-sm float-right' onClick={handleSave}>
                <Icon className="fa fa-floppy-o"></Icon>{isSaving ? " Saving..." : " Save"}</Button>
        </Modal.Footer>
    </Modal>
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ resetPassword }, dispatch)
});

export default connect(null, mapDispatchToProps)(ResetPassword);